// Native
import { Pipe, PipeTransform } from '@angular/core';

// Imported
import * as moment from 'moment';

// moment.locale('ru');

@Pipe({
  name: 'moment',
  pure: false
})
export class MomentPipe implements PipeTransform {

  transform(value: any, key: string = 'dmyhm'): any {
    if (!value) return value;
    let format: string;
    const formats: any = {
      dmy: 'DD.MM.YYYY',
      dmyhm: 'DD.MM.YYYY HH:mm',
      dmywhm: 'DD.MM.YYYY, ddd, HH:mm',
      dmyhms: 'DD.MM.YYYY HH:mm:ss',
      hms: 'HH:mm:ss'
    };


    format = formats[key];

    return moment(value).format(format);
  }
}
